import { Breadcrumb, Flex, Row, Space, Tabs, Button, Card, ConfigProvider } from "antd";

import { MainLayout } from "components/layouts";
import ContentMenu from "./ContentMenu";
// import "./RequestApprovalMenuCss.css"
import { useTranslation } from "react-i18next";
import MyTabsMenu from "components/elements/MyTabs/MyTabsMenu";
import { CopyOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { CardContainer } from "components/elements";
import { useState } from "react";
import { FilterOutlined } from "@ant-design/icons";
import PendingApprovalFilter from "./PendingApprovalFilter";
import WarningletterFilter from "./WarningletterFilter";
import MovementFilter from "./MovementFilter";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import ModalMyRequest from "components/elements/Modal/ModalMyRequest";

const MainContent = ({
    getPage = () => { },
    onSearchWarning = () => { },
    onSearchMovement = () => { },
    handleMenuChange = () => { },
    modifiedEmployeeOptions = [],
    modifiedCompanyRegulationOptions = [],
    modifiedPenaltiesOptions = [],
    modifiedMovementGroupOptions = [],
    selectedMenu = '',
}) => {
    const { t } = useTranslation();
    const { roles } = useSelector((state) => state.company);
    const [useFilter, setUseFilter] = useState(false);
    function getItem(rules, i18n_key, label, key, icon, children, type) {
        let list = [...roles]
        if (!list.includes(rules)) {
            return {}
        }
        return {
            i18n_key,
            key,
            children,
            label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {icon}{label}
                </div>
            ),
            type,
        };
    }

    const REQUEST_APPROVAL_MENU = [
        getItem("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|REQUEST_APPROVAL", "request_approval", t('pending-approval-list'), "pending_approval"),
        // getItem("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|MY_REQUEST", "my_request", t('request.request'), "request"),
        getItem("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|WARNING_LETTER", "warning_letter", t('warning-letter'), "warning_letter"),
        // getItem("ACCESS_MY_DOCUMENT|REQUEST_APPROVAL_LIST|MOVEMENT", "movement", t('setting.movement'), "movement")
    ];

    return (
        <MainLayout>
            <Space
                style={{
                    width: "100%",
                    backgroundColor: "transparent",
                }}
                size={24}
                direction="vertical"
            >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("document_request.header"), href: "" },
                        { title: t("request_approval.header") }
                    ]} />
                    <h2>{t("request_approval.header")}</h2>
                </Flex>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                itemHoverColor: "var(--tab-color)",
                                itemActiveColor: "var(--tab-color)"
                            },
                        },
                    }}
                >
                    <Tabs items={REQUEST_APPROVAL_MENU} onChange={handleMenuChange} />
                </ConfigProvider>

                {(selectedMenu == "warning_letter" || selectedMenu == "movement") && (<Row style={{ marginBottom: 12, justifyContent: "end" }} >
                    <Button type="default" onClick={() => setUseFilter(!useFilter)}
                        style={{ padding: "10px 16px", height: "max-content", borderRadius: "8px" }}
                    >
                        <Flex align="center" justify="center" gap={8}>
                            <FilterIcon />
                            <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                        </Flex>
                    </Button>
                </Row>)}
                {(useFilter && selectedMenu == "warning_letter") && (
                    <Card width="100%" height="fit-content" style={{
                        borderRadius: "8px",
                        backgroundColor: "white",
                        border: "1px solid #EAECF0"
                    }}>
                        <WarningletterFilter
                            // dataFlag={pendingTab}
                            // leaveGroupOptions={modifiedLeaveGroupOptions}
                            companyRegulationOptions={modifiedCompanyRegulationOptions}
                            employeeOptions={modifiedEmployeeOptions}
                            penaltiesOptions={modifiedPenaltiesOptions}
                            // offsiteOptions={modifiedOffSiteOptions}
                            onSubmit={onSearchWarning}
                        />
                    </Card>
                )}
                {/* {(useFilter && selectedMenu == "movement") && (
                    <CardContainer width="100%" height="fit-content">
                        <MovementFilter
                            // dataFlag={pendingTab}
                            // leaveGroupOptions={modifiedLeaveGroupOptions}
                            companyRegulationOptions={modifiedCompanyRegulationOptions}
                            employeeOptions={modifiedEmployeeOptions}
                            penaltiesOptions={modifiedPenaltiesOptions}
                            movementGroupOptions={modifiedMovementGroupOptions}
                            onSubmit={onSearchMovement}
                        />
                    </CardContainer>
                )} */}

                {getPage()}
            </Space>
        </MainLayout>
    );
};

export default MainContent;
